import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const LoteGestionApp = Loadable(lazy(() => import('./view/LoteGestion')))

export const loteRoutesMap = {
  gestion: {
    path: '/lote/gestion',
    name: 'Lotes',
    action: 'LOTES',
  },
  registro: {
    path: '/lote/nuevo',
    name: 'Nuevo lote',
    action: 'ADMINISTRAR_LOTES',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const loteRoutes = [
  {
    path: loteRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <LoteGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: loteRoutesMap.upsert.path,
    element: <LoteRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default loteRoutes
